module.exports = __webpack_public_path__ + "img/img1.f83ca119.svg";